/**
 * @module FieldControls
 */
import { ClickAwayListener, FormControl, Icon, InputAdornment, TextField, Typography } from '@material-ui/core';
import { deepMerge } from '@sensenet/client-utils';
import React, { useState } from 'react';
import { SketchPicker } from 'react-color';
import { changeTemplatedValue } from "../helpers.js";
import { defaultLocalization } from "./localization.js";
const style = {
  input: {
    width: 80
  },
  pickerContainer: {
    position: 'absolute',
    left: '24px',
    top: '20px',
    zIndex: 10
  }
};
const renderIconDefault = (name, color) => {
  return /*#__PURE__*/React.createElement(Icon, {
    style: {
      color
    }
  }, name);
};

/**
 * Field control that represents a Color field. Available values will be populated from the FieldSettings.
 */
export const ColorPicker = props => {
  var _props$localization, _props$fieldValue;
  const localization = deepMerge(defaultLocalization.colorPicker, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.colorPicker);
  const [value, setValue] = useState((_props$fieldValue = props.fieldValue) !== null && _props$fieldValue !== void 0 ? _props$fieldValue : props.actionName === 'new' ? changeTemplatedValue(props.settings.DefaultValue) || '' : '');
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const handleChange = color => {
    var _props$fieldOnChange;
    (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, color.hex);
    setValue(color.hex);
  };
  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(TextField, {
        label: props.settings.DisplayName,
        type: "text",
        name: props.settings.Name,
        id: props.settings.Name,
        placeholder: props.settings.DisplayName,
        required: props.settings.Compulsory,
        disabled: props.settings.ReadOnly,
        value: value,
        onClick: () => setIsPickerOpen(true),
        helperText: props.hideDescription ? undefined : props.settings.Description,
        InputProps: {
          startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
            position: "start"
          }, props.renderIcon ? props.renderIcon('lens') : renderIconDefault('lens', value || 'transparent'))
        }
      }), isPickerOpen ? /*#__PURE__*/React.createElement(ClickAwayListener, {
        onClickAway: () => setIsPickerOpen(false)
      }, /*#__PURE__*/React.createElement("div", {
        style: style.pickerContainer
      }, /*#__PURE__*/React.createElement(SketchPicker, {
        color: value,
        onChangeComplete: handleChange,
        onSwatchHover: handleChange,
        disableAlpha: true
      }))) : null);
    case 'browse':
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        gutterBottom: true
      }, props.settings.DisplayName), props.fieldValue ? /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, props.renderIcon ? props.renderIcon('lens') : renderIconDefault('lens', value), /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        gutterBottom: true,
        style: {
          marginLeft: '0.5rem'
        }
      }, value)) : /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        gutterBottom: true,
        style: {
          marginLeft: '0.5rem'
        }
      }, localization.noValue));
  }
};
//# sourceMappingURL=color-picker.js.map